<script>
import Tabs from './index'
export default {
    name: 'TabsScroller',
    extends: Tabs,
    data() {
        return {
            alwaysShowTabs: true,
            supressDetect: false,
            // Used by DetectSection and scrollToSection
            scrollPosTopPadding: 50,
        }
    },
    mounted() {
        // Start listening to scroll and setup the slide marker once the dom is fully ready
        this.$nextTick(function () {
            // Listen for Scroll Events
            window.addEventListener('scroll', this.handleScroll)
        })
    },
    destroyed() {
        // Stop listening for scroll events
        window.removeEventListener('scroll', this.handleScroll)
    },
    methods: {
        // Central catch for scroll events
        handleScroll() {
            // Disabled when we know where we are going
            if (this.supressDetect) return
            this.detectStickHeader()
            this.detectSection()
        },
        selectTab(index, thenScroll) {
            // Scroll to Top
            if (index === 'Top') {
                this.$scrollTo('#top', 500, {
                    onStart: () => {
                        // We know where to go so disable Detect methods
                        this.supressDetect = true
                        // We know the header needs to be Fixed now so just do it
                        // When the header is Fixed it auto slides to the first tab so we don't need to worry about that
                        this.stickHeader(false)
                    },
                    onCancel: () => {
                        // Turn detection back on if they interrupt the auto scroll
                        this.supressDetect = false
                    },
                    onDone: () => {
                        // Turn detection back on when we are done
                        this.supressDetect = false
                    },
                })
                return
            }
            // Scroll to the section selected by default
            // We don't want to scroll if we are Detecting the tab based on user scroll
            if (typeof thenScroll === 'undefined') thenScroll = true
            if (thenScroll) this.scrollToSection(index)
            else this.slideMarker(index)
        },
        // Fix the tab header when user scrolls past it
        detectStickHeader() {
            // It would be super cool if we could cache this and update anytime the dom changes...
            const sticky =
                this.$refs.container.getBoundingClientRect().top +
                document.documentElement.scrollTop
            // Determine if the user is beyond the header or not
            if (window.pageYOffset >= sticky) {
                this.stickHeader(true)
            } else if (this.$refs.header?.classList.contains('-fixed')) {
                this.stickHeader(false)
            }
        },
        // Detect if the user has scrolled into a new tab section then move the underline marker
        detectSection() {
            // Get a list of our available tabs
            const sections = this.tabs
            // Loop through each section
            for (let i = 0; i < sections.length; i++) {
                const section = sections[i].$el
                // getBoundingClientRect + pageYOffset is way more accurate than offsetTop
                const top =
                    section.getBoundingClientRect().top +
                    window.pageYOffset -
                    this.scrollPosTopPadding
                // If our current position is within a specific section select that tab
                if (window.pageYOffset > top && window.pageYOffset < top + section.offsetHeight)
                    this.selectTab(i, false)
            }
        },
        // Controls the Fix/UnFix of tab header
        stickHeader(bool) {
            if (bool) {
                // Fix the header
                this.$refs.header?.classList.add('-fixed')
                // Set the width of the header to fill the container
                this.$refs.header.style.width = this.$refs.container.offsetWidth + 'px'
            } else {
                // Revert the header to a docked state
                this.$refs.header?.classList.remove('-fixed')
                this.$refs.header.style.width = 'auto'
                // Guarantee that if we ever doc the bar the slider goes back to home
                this.slideMarker(0)
            }
        },
        // Scroll down to a section when a user clicks a corresponding tab
        scrollToSection(index) {
            this.$nextTick(function () {
                // Smooth scroll to that section.
                this.$scrollTo(this.tabs[index].$el, 500, {
                    offset: -Math.abs(this.scrollPosTopPadding),
                    onStart: () => {
                        // Don't bother with Detect methods on scroll, save the effort since we know what needs to happen.
                        this.supressDetect = true
                        // We know they will scroll passed the header so just fix it.
                        this.stickHeader(true)
                        // We know where the marker needs to be and want it to move while we scroll.
                        this.slideMarker(index)
                    },
                    onCancel: () => {
                        // Turn detection back on if they interrupt the auto scroll
                        this.supressDetect = false
                    },
                    onDone: () => {
                        // Turn detection back on when we are done
                        this.supressDetect = false
                    },
                })
            })
        },
    },
}
</script>

<style lang="stylus">
.tab-section:not(:first-child) .sectionTitle
    padding-top 25px
    border-top 1px solid theme('colors.gray.light')
</style>
